module.exports = __webpack_public_path__ + "media/images/version_merge/check_modal-effff3814b0145334f8e19547a576bd7.svg";